// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator__s3NfK","active":"Indicator_active__1JoQM"};